import React, { useState, useEffect } from "react";
import {
	Box,
	Button,
	Heading,
	Divider,
	IconButton,
	Input,
	NumberInput,
	NumberInputField,
	Table,
	Thead,
	Tbody,
	Tr,
	Th,
	Td,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";

export default function ChartDataEditor({ onDataChange, isEn = true, onSave, initData }) {
	const [data, setData] = useState(null);
// 	const initialJson = {
// 		labels: ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
// 		datasets: [
// 			{
// 				label: isEn ? "General Insurance" : "ធានារ៉ាប់រងទូទៅ",
// 				data: [86640270, 101383939, 114485277, 122965797, 132340704, 150727745, 147636549],
// 				backgroundColor: "#2980b9",
// 			},
// 			{
// 				label: isEn ? "Life Insurance" : "ធានារ៉ាប់រងអាយុជីវិត",
// 				data: [100770354, 144400835, 153374081, 170458869, 193808543, 193539426, 200407724],
// 				backgroundColor: "#e67e22",
// 			},
// 			{
// 				label: isEn ? "Micro insurance" : "ធានារ៉ាប់រងខ្នាតតូច",
// 				data: [9259753, 7059819, 5034998, 4129267, 5716368, 0, 8872543],
// 				backgroundColor: "#16a085",
// 			},
// 		],
// 	};

	useEffect(() => {
		setData(initData?.data);
	}, [initData]);

	if (!data) return <div>Loading...</div>;

	const handleLabelChange = (index, value) => {
		const updated = { ...data };
		updated.labels[index] = value;
		setData(updated);
		onDataChange?.(updated);
	};

	const handleValueChange = (datasetIndex, valueIndex, value) => {
		const updated = { ...data };
		updated.datasets[datasetIndex].data[valueIndex] = Number(value);
		setData(updated);
		onDataChange?.(updated);
	};

	const handleAddYear = () => {
		const updated = { ...data };
		updated.labels.push(`Year ${updated.labels.length + 1}`);
		updated.datasets.forEach((ds) => ds.data.push(0));
		setData(updated);
		onDataChange?.(updated);
	};

	const handleRemoveYear = (index) => {
		const updated = { ...data };
		updated.labels.splice(index, 1);
		updated.datasets.forEach((ds) => ds.data.splice(index, 1));
		setData(updated);
		onDataChange?.(updated);
	};

	return (
		<Box p={5} borderWidth="1px" borderRadius="lg" bg="white">
			<Heading size="md" mb={4}>
				Edit Chart Data
			</Heading>

			{/* Scroll wrapper */}
			<Box overflowX="auto">
				<Table size="sm" minWidth="max-content">
					<Thead>
						<Tr>
							<Th>Dataset</Th>
							{data.labels.map((label, i) => (
								<Th key={i}>
									<Input
										value={label}
										onChange={(e) => handleLabelChange(i, e.target.value)}
										size="sm"
										w="120px"
									/>
									<IconButton
										size="xs"
										colorScheme="red"
										icon={<CloseIcon boxSize={2} />}
										onClick={() => handleRemoveYear(i)}
										aria-label="Remove year"
										ml={1}
									/>
								</Th>
							))}
						</Tr>
					</Thead>
					<Tbody>
						{data.datasets.map((dataset, datasetIndex) => (
							<Tr key={datasetIndex}>
								<Td>{dataset.label}</Td>
								{dataset.data.map((value, valueIndex) => (
									<Td key={valueIndex}>
										<NumberInput
											value={value}
											precision={2}
											step={0.01}
											onChange={(val) =>
												handleValueChange(datasetIndex, valueIndex, val)
											}
											size="sm"
											w="120px"
										>
											<NumberInputField />
										</NumberInput>
									</Td>
								))}
							</Tr>
						))}
					</Tbody>
				</Table>
			</Box>

			<Button size="sm" colorScheme="green" mt={3} onClick={handleAddYear}>
				+ Add Year
			</Button>

			<Divider my={4} />

			<Button
				colorScheme="blue"
				onClick={() => {
					console.log("Updated data:", data);
					onDataChange?.(data);
					onSave(data)
				}}
			>
				Save Changes
			</Button>
		</Box>

	);
}
